import { Icon, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';

import { OperationType } from '../../../../../../components/OperationType';

interface OperationTypeSectionProps {
  onToggle: () => void;
  isOpen: boolean;
}

export const OperationTypeSection: React.FC<Partial<OperationTypeSectionProps>> = ({
  isOpen,
  onToggle,
}) => {
  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });

  if (isMobile) {
    return (
      <Pressable
        onPress={onToggle}
        borderRadius={BoxRadius.sm}
        alignItems="center"
        flexDirection="row"
        justifyContent="space-between"
        {...(isOpen && {
          pb: Spacing['stack.xxxs'],
          mb: Spacing['stack.xxxs'],
          borderBottomColor: Color['neutral.lightest'],
          borderBottomWidth: '1px',
        })}>
        <OperationType title="Resgate" />
        <Icon
          name={isOpen ? 'ChevronUp' : 'ChevronDown'}
          size="xs"
          color={Color['neutral.black']}
        />
      </Pressable>
    );
  }

  return (
    <VStack maxW="65px">
      <OperationType title="Resgate" />
    </VStack>
  );
};
